import { render, staticRenderFns } from "./ConfiguracaoDepartamento.vue?vue&type=template&id=15274485&"
import script from "./ConfiguracaoDepartamento.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoDepartamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports